// extracted by mini-css-extract-plugin
export default {"icon":"social_links_icon__9ScXL","links":"social_links_links__Xk2yW"};